import { styled } from "@mui/material";
import React from "react";
import Tooltip from "../../Tooltip";

const Title = styled("div")`
  font-size: ${(props) => props.theme.wsc.typography.body1.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body1.fontWeight};
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: max-content;
`;

const SubTitle = styled("div")`
  font-size: ${(props) => props.theme.wsc.typography.body3.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body3.fontWeight};
  color: ${(props) => props.theme.wsc.palette.neutral[300]};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  code {
    background: ${(props) => props.theme.wsc.palette.neutral[600]};
    padding: 2px 4px;
    border-radius: ${(props) => props.theme.wsc.radius.l};
  }
`;

const Wrapper = styled("div")<{ width: string }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.wsc.spacing[0]};
  width: ${(props) => props.width};
`;

type CustomTooltipProps = Omit<
  React.ComponentProps<typeof Tooltip>,
  "children"
>;

type FloatingActionBarDescriptionProps = {
  tooltipProps?: CustomTooltipProps;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  width?: string;
};

export default function FloatingActionBarDescription({
  tooltipProps = {},
  title,
  subTitle,
  width = "300px",
}: FloatingActionBarDescriptionProps) {
  return (
    <Wrapper width={width}>
      <Tooltip placement="top-start" type="light" {...tooltipProps}>
        <Title>{title}</Title>
      </Tooltip>
      <SubTitle>{subTitle}</SubTitle>
    </Wrapper>
  );
}
